export default "__VITE_ASSET__beb46958__"